import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import Shimmer from '@techsoftware/happay-widgets/Shimmer';
import { isMobile } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import ContainerShimmer from '../../ContainerView/containerShimmer';

export default function VendorShimmer() {
  return (
    <Grid
      container
      justify="center"
      alignItems="flex-start"
      className="margin-t-118 detail-container"
    >
      <Grid item xs={24} sm={14} md={14} xl={14} lg={14}>
        <ContainerShimmer count={2} />
        <ContainerShimmer count={6} />
        <ContainerShimmer count={6} />
      </Grid>
    </Grid>
  );
}
